import React, { useMemo } from "react";
import moment from "moment";

import { Table } from "../../../Common/Table";

import { InventoryNameCell } from "../Vehicle/VehicleOverview/VehiclesTable/TableCells/FixedNameCell/InventoryNameCell";
import { VehicleVINCell } from "../Vehicle/VehicleOverview/VehiclesTable/TableCells/VehicleVINCell";
import { VehicleColourBadge } from "../../../Common/VehicleColourBadge";
import { EditableCell } from "../../../Common/Table/EditableCell";

export const InventoryList = ({ inventories, updateInventoryInline, userSession, history }) => {
	const updateAdditionalDataInput = (currentAdditionalData, attributeName, newValue) => {
		const cleanedAdditionalData = currentAdditionalData.filter(data => data.name !== attributeName);

		return [...cleanedAdditionalData, { name: attributeName, value: newValue }];
	};

	const updateInventoryCellData = async (currentInventory, attributeToUpdate, newValue) => {
		const attributeName = attributeToUpdate.split('.')[1] || attributeToUpdate; // attributeToUpdate can be "additionalData.name" or "name"

		const currentAdditionalData = currentInventory.additionalData?.length
			? currentInventory.additionalData.map(data => ({ name: data.name, value: data.value }))
			: [];

		const additionalData = attributeToUpdate.includes('additionalData')
			? updateAdditionalDataInput(currentAdditionalData, attributeName, newValue)
			: currentAdditionalData;

		const inventoryInput = {
			id: currentInventory.id,
			updatedBy: userSession.user.email,
			orderNo: currentInventory.orderNo,
			dealerId: currentInventory.dealerId,
			additionalData,
		};

		return updateInventoryInline(inventoryInput);
	}

	const columns = useMemo(
		() => [
			{
				Header: () => (
					<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
						<span>Vehicle</span>
						<span style={{ width: '80px' }}>Order</span>
					</div>
				),
				accessor: 'displayName',
				sticky: 'left',
				width: 400,
				minWidth: 300,
				Cell: ({ row }) => <InventoryNameCell history={history} vehicle={row.original} />
			},
			{
				Header: 'VIN',
				accessor: 'vin',
				width: window.innerWidth > 1850 ? 260 : 220,
				Cell: ({ value }) => <VehicleVINCell VIN={value} />
			},
			{
				Header: 'Dealer ID',
				accessor: 'dealerId',
				width: 120,
			},
			{
				Header: 'Location Status',
				accessor: 'locationStatus',
        width: 200,
				Cell: ({ row }) => {
					const { locationSeq, locationStatus } = row.original;
					return <span className="truncate">{locationSeq ? `${locationSeq} - ` : ''}{locationStatus}</span>
				}
			},
			{
				Header: 'Model Code',
				accessor: 'modelCode',
				width: 120,
			},
			{
				Header: 'Plate',
				accessor: 'additionalData.licensePlate',
				Cell: ({ value, row, column }) => <EditableCell {...{ value, row, column }} updateData={updateInventoryCellData} placeholder="Licence Plate" modifier={(value) => value.toUpperCase()} />
			},
			{
				Header: 'Reason For Order',
				accessor: 'additionalData.reasonForOrder',
				minWidth: 180,
				Cell: ({ value, row, column }) => <EditableCell {...{ value, row, column }} updateData={updateInventoryCellData} placeholder="Use Case" />
			},
			{
				Header: 'Exterior Colour',
				accessor: 'exteriorColor',
				width: 220,
				minWidth: 190,
				Cell: ({ row }) => {
					const { globalExteriorColor, exteriorColor } = row.original;
					return <VehicleColourBadge colourName={exteriorColor} colourCode={globalExteriorColor} />
				}
			},
			{
				Header: 'Interior Colour',
				accessor: 'interiorColor',
				width: 220,
				minWidth: 190,
				Cell: ({ row }) => {
					const { globalInteriorColor, interiorColor } = row.original;
					return <VehicleColourBadge colourName={interiorColor} colourCode={globalInteriorColor} />
				}
			},
			{
				Header: 'Ship To',
				accessor: 'additionalData.shipTo',
				width: 220,
				Cell: ({ value, row, column }) => <EditableCell {...{ value, row, column }} updateData={updateInventoryCellData} />
			},
			{
				Header: 'Offline Date',
				accessor: 'offlineDate',
				width: 160,
				Cell: ({ value }) => <>{Boolean(value) && (moment(value).format('MMM DD, YYYY'))}</>
			},
			{
				Header: 'FHI Departure',
				accessor: 'fhiDeparture',
				width: 160,
				Cell: ({ value }) => <>{Boolean(value) && (moment(value).format('MMM DD, YYYY'))}</>
			},
			{
				Header: 'Vessel ETA',
				accessor: 'vesselEta',
				width: 160,
				Cell: ({ value }) => <>{Boolean(value) && (moment(value).format('MMM DD, YYYY'))}</>
			},
			{
				Header: 'First Available Date',
				accessor: 'additionalData.firstAvailableDate',
				width: 160,
				Cell: ({ value, row, column }) => <EditableCell {...{ value, row, column }} updateData={updateInventoryCellData} placeholder="MMM DD, YYYY" isDatePicker />
			},
			{
				Header: 'Status Changed Last',
				accessor: 'metadata.createdAt',
				width: 160,
				Cell: ({ value }) => <>{Boolean(value) && (moment(value).format('MMM DD, YYYY'))}</>
			},
			// {
			// 	Header: '',
			// 	accessor: 'menu',
			// 	width: 100,
			// 	Cell: ({ row }) => <VehicleMenuCell vehicle={row.original} {...{ history, match, location }} />
			// },
		],
		[inventories]
	)

	const data = useMemo(() => inventories, [inventories]);

	return (
		<div className="vehicles-table">
			<Table columns={columns} data={data} fixedHeader />
		</div>
	)
}
